module.exports = __webpack_public_path__ + "img/Hero_image.67d3c344.png";